<template>
    <div>
        <div class="lines">
            <div class="line" v-for="(line, index) in value" :key="index" :class="{ 'is-processing': isProcessing(value[index]), 'is-done': isDone(value[index]) }">
                <a class="remove-line" href="#" @click.prevent="removeLine(index)" title="Opname verwijderen">&times;</a>

                <div class="row">
                    <div class="col-4">
                        <ModelSelect :options="types" v-model="value[index].type" placeholder="Selecteer een type"></ModelSelect>
                    </div>

                    <div class="col-8">
                        <div class="row date-row" v-for="(date, dateIndex) in line.dates" :key="dateIndex">
                            <div class="col-4">
                                <div class="form-group date-small">
                                    <datetime v-model="value[index].dates[dateIndex].date" value-zone="local"></datetime>
                                </div>
                            </div>

                            <div class="col-8">
                                <MultiSelect :options="getUsers" :selected-options="formatInspectors(value[index].dates[dateIndex].inspectors)" @select="onSelect(index, dateIndex, ...arguments)" :search="false" placeholder="Selecteer experts"></MultiSelect>
                            </div>

                            <a href="#" @click.prevent="removeDate(index, dateIndex)" class="btn-remove" title="Datum verwijderen" v-if="dateIndex > 0">&times;</a>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <a href="#" class="add-date" @click.prevent="addDate(index)"><i class="icon icon-add"></i> Datum toevoegen</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a href="#" class="btn-big" @click.prevent="addRule"><i class="icon icon-add"></i> Opnamemoment toevoegen</a>
    </div>
</template>

<script>
	import { FETCH_ALL_USERS } from '@/store/modules/users'
	import { ModelSelect, MultiSelect } from 'vue-search-select'
	import moment from 'moment-timezone'

	export default {
		props: {
			value: {
				type: Array,
				default () {
					return []
				},
			},
			startDate: {
				type: String,
				default () {
					return moment().format('YYYY-MM-DD HH:MM:SS')
				},
			},
		},

		components: { ModelSelect, MultiSelect },

		data () {
			return {
				type: null,
				types: [
					{ value: 1, text: 'Vooropname' },
					{ value: 2, text: 'Tussenopname' },
					{ value: 3, text: 'Extra opname' },
					{ value: 4, text: 'Eindopname' },
				],
				users: [],
				inspectors: [],
			}
		},

		computed: {
			getStartDate () {
				return moment.utc(this.startDate).format()
			},
			getUsers () {
				let users = this.users.filter((user) => {
					if (user.roles.map((role) => {
						return role.name
					}).indexOf('Opname expert') >= 0) {
						return user
					}
				})

				return users.map((user) => {
					return { value: user.id, text: user.name }
				})
			},
		},

		mounted () {
			this.fetchData()
		},

		methods: {
			isProcessing (line) {
				return ( line.status && line.status === 2 );
			},

			isDone (line) {
				return ( line.status && line.status === 3 );
			},

			formatInspectors (value) {
				if (value.length > 0 && value[0].email) {
					return value.map((inspector) => {
						return { text: inspector.name, value: inspector.id }
					})
				}

				return value
			},

			addRule () {
				console.log(this.getStartDate);

				this.value.push({
					type: null,
					dates: [
						{
							date: this.getStartDate,
							inspectors: [],
						},
					],
				})
				this.update()
			},

			onSelect (index, dateIndex, items) {
				this.value[index].dates[dateIndex].inspectors = items
				this.update()
			},

			addDate (index) {
				this.value[index].dates.push({
					date: null,
					inspectors: [],
				})
				this.update()
			},

			removeDate (lineIndex, dateIndex) {
				this.value[lineIndex].dates.splice(dateIndex, 1)
				this.update()
			},

			removeLine (index) {
				this.$emit('removeInspection', this.value[index])

				this.value.splice(index, 1)
				this.update()
			},

			fetchData () {
				this.$store.dispatch(FETCH_ALL_USERS).then((data) => {
					this.users = data
				})
			},

			update () {
				this.$emit('input', this.value)
			},
		},
	}
</script>

<style lang="scss" scoped>
    .btn-big {
        padding: 20px 25px;
        border: 2px dashed #e6e6e6;
        text-align: center;
        font-size: 16px;
        margin-bottom: 10px;
        color: #303E49 !important;
        font-weight: 600;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .icon {
            margin-top: 3px;
            line-height: .93;
            margin-right: 10px;
            font-size: 22px;
        }

        &:hover {
            text-decoration: none;
        }
    }

    .line {
        position: relative;
        border: 1px solid #e6e6e6;
        margin-bottom: 10px;
        padding: 30px 15px 15px 15px;

        .remove-line {
            position: absolute;
            top: -1px;
            right: -1px;
            background: #e4002b;
            color: #FFF;
            border-bottom-left-radius: 10px;
            font-size: 22px;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            line-height: 0.93;

            &:hover {
                text-decoration: none;
            }
        }

        &.is-processing {
            &:after {
                display: flex;
                font-size: 18px;
                font-weight: 700;
                text-transform: uppercase;
                color: #F18903;
                align-items: center;
                justify-content: center;
                content: 'Lopende opname';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: rgba(255, 255, 255, .8);
                z-index: 5;
            }

            .remove-line,
            .btn-remove {
                display: none !important;
            }
        }

        &.is-done {
            &:after {
                display: flex;
                font-size: 18px;
                font-weight: 700;
                text-transform: uppercase;
                color: #F18903;
                align-items: center;
                justify-content: center;
                content: 'Afgeronde opname';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: rgba(255, 255, 255, .8);
                z-index: 5;
            }

            .remove-line,
            .btn-remove {
                display: none !important;
            }
        }

    }

    .add-date {
        margin-top: 5px;
        display: flex;
        align-items: center;
        text-align: left;

        .icon {
            line-height: 0.93;
            margin-right: 5px;
        }

        &:hover {
            text-decoration: none;
        }
    }

    .vdatetime {
        input {
            padding: 3px 15px !important;
        }
    }

    .form-group {
        margin: 0 0 10px 0;
        padding-top: 0;
    }

    .date-row {
        position: relative;
        margin-bottom: 10px;

        .dropdown {
            margin-right: 20px;
        }
    }

    .btn-remove {
        position: absolute;
        top: 11px;
        right: 11px;
        background: #e6e6e6;
        border-radius: 50%;
        font-size: 22px;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        line-height: 0.93;

        &:hover {
            text-decoration: none;
        }
    }
</style>